export const DocumentModeDictionary = {
  NO_NEED: 0,
  OPTIONAL: 1,
  MANDATORY: 2,
};
